import moment from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { DISPLAY_DATE_FORMAT } from '../../constants/dates';
import { Status } from '../../graphql/types';
import {
  DeliveredStatus,
  InvoicedStatus,
  PartDeliveredStatus,
  PartInvoicedStatus,
  PartShippedStatus,
  PotentialStatus,
  ProcessedStatus,
  ReceivedStatus,
  RejectedStatus,
  ShippedStatus,
  White,
} from '../../styles/colours';

const statusColor = (status: Status): string => {
  switch (status) {
    case 'RECEIVED':
      return ReceivedStatus;
    case 'PROCESSED':
      return ProcessedStatus;
    case 'PART_SHIPPED':
      return PartShippedStatus;
    case 'SHIPPED':
      return ShippedStatus;
    case 'PART_DELIVERED':
      return PartDeliveredStatus;
    case 'DELIVERED':
      return DeliveredStatus;
    case 'PART_INVOICED':
      return PartInvoicedStatus;
    case 'INVOICED':
      return InvoicedStatus;
    case 'POTENTIAL':
      return PotentialStatus;
    default:
      return RejectedStatus;
  }
};

export const toDisplayStatus = (status: Status): string => {
  switch (status) {
    case 'RECEIVED':
      return 'Submitted';
    case 'PROCESSED':
      return 'Scheduled';
    case 'PART_SHIPPED':
      return 'Part shipped';
    case 'SHIPPED':
      return 'In delivery';
    case 'PART_DELIVERED':
      return 'Part delivered';
    case 'DELIVERED':
      return 'Delivered';
    case 'PART_INVOICED':
      return 'Part invoiced';
    case 'INVOICED':
      return 'Billed';
    case 'REJECTED':
      return 'Rejected';
    case 'POTENTIAL':
      return 'Potential';
    default:
      return 'Rejected';
  }
};

const StyledStatus = styled.span<{ status: Status }>`
  display: inline-block;
  font-size: 0.8rem;
  border-radius: 4px;
  background: ${({ status }) => statusColor(status)};
  text-align: center;
  color: ${White};
  white-space: nowrap;
  width: 6rem;
`;

const toTitleDate = (titleDate: string) => {
  const dateFormatSetting = localStorage.getItem('dateFormat');
  const displayDateFormat = dateFormatSetting
    ? dateFormatSetting
    : DISPLAY_DATE_FORMAT;
  return moment(titleDate).format(displayDateFormat + ' HH:mm:ss');
};

export const StatusBadge: FC<{ status: Status; title?: string }> = ({
  status,
  title,
}) => {
  return (
    <StyledStatus
      title={
        title
          ? status +
            '\n' +
            'Status Last Updated on:' +
            '\n' +
            toTitleDate(title)
          : status
      }
      status={status}
    >
      {toDisplayStatus(status)}
    </StyledStatus>
  );
};
